import Bowser from "bowser";

const ua = window.navigator.userAgent;
const DetectedBrowser = Bowser.getParser(ua);

let Browser = {};

Browser.mobilesafari = () => {
	if (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) {
		// We are on a touch device, probably iOS
		if (DetectedBrowser.getBrowserName() === 'Safari') {
			return true;
		}
	}

	return false;
}

Browser.chrome = () => {
	if (DetectedBrowser.getBrowserName() === 'Chrome') {
		return true;
	}

	return false;
}

Browser.ios = () => {
	return /ip(ad|od|hone)/i.test(ua);
}

Browser.android = () => {
	return /android/i.test(ua);
}

Browser.androidphone = () => {
	var height, width;
	if (!Browser.android()) {
		return false;
	}

	// switch to phone layout if we go below our min screen width
	width = window.screen.width;
	height = window.screen.height;

	if ((width < 640) && (height < 640)) {
		return true;
	}

	return false;
}

Browser.iphone = () => {
	return /iphone/i.test(ua);
}

Browser.winphone = () => {
	return /Windows phone/i.test(ua);
}

Browser.phone = () => {
	return Browser.iphone() || Browser.winphone() || Browser.androidphone();
}

Browser.mobile = () => {
	return Browser.ios() || Browser.android() || Browser.winphone();
}

export default Browser;